const useEnv = () => {
  const isTest = () => {
    const { origin } = window.location;
    return origin.includes('fanyi.testsite') || origin.includes('web.cicd');
  };

  return { isTest };
};

export default useEnv;
